export default __webpack_public_path__ + "static/media/space blue.83eb3f08.png";